/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AuthenticationCredentialsRequest,
    AuthenticationCredentialsRequestFromJSON,
    AuthenticationCredentialsRequestToJSON,
    AuthenticationPasswordRequest,
    AuthenticationPasswordRequestFromJSON,
    AuthenticationPasswordRequestToJSON,
    AuthenticationPasswordResetRequest,
    AuthenticationPasswordResetRequestFromJSON,
    AuthenticationPasswordResetRequestToJSON,
    AuthenticationResponse,
    AuthenticationResponseFromJSON,
    AuthenticationResponseToJSON,
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ChangeExpiredPasswordRequest,
    ChangeExpiredPasswordRequestFromJSON,
    ChangeExpiredPasswordRequestToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
    UserResponse,
    UserResponseFromJSON,
    UserResponseToJSON,
} from '../models';

export interface AuthenticateByCredentialsRequest {
    authenticationCredentialsRequest?: AuthenticationCredentialsRequest;
}

export interface ChangeExpiredPasswordOperationRequest {
    changeExpiredPasswordRequest: ChangeExpiredPasswordRequest;
}

export interface CreatePasswordResetRequest {
    authenticationPasswordResetRequest: AuthenticationPasswordResetRequest;
}

export interface ResetPasswordRequest {
    authenticationPasswordRequest: AuthenticationPasswordRequest;
}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI {

    /**
     * Authenticates the user by the given username and password pair.
     */
    async authenticateByCredentialsRaw(requestParameters: AuthenticateByCredentialsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<AuthenticationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/credentials`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthenticationCredentialsRequestToJSON(requestParameters.authenticationCredentialsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticationResponseFromJSON(jsonValue));
    }

    /**
     * Authenticates the user by the given username and password pair.
     */
    async authenticateByCredentials(requestParameters: AuthenticateByCredentialsRequest = {}, initOverrides?: RequestInit): Promise<AuthenticationResponse> {
        const response = await this.authenticateByCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change user expired password to new one.
     */
    async changeExpiredPasswordRaw(requestParameters: ChangeExpiredPasswordOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.changeExpiredPasswordRequest === null || requestParameters.changeExpiredPasswordRequest === undefined) {
            throw new runtime.RequiredError('changeExpiredPasswordRequest','Required parameter requestParameters.changeExpiredPasswordRequest was null or undefined when calling changeExpiredPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/changeExpiredPassword`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeExpiredPasswordRequestToJSON(requestParameters.changeExpiredPasswordRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Change user expired password to new one.
     */
    async changeExpiredPassword(requestParameters: ChangeExpiredPasswordOperationRequest, initOverrides?: RequestInit): Promise<void> {
        await this.changeExpiredPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * Creates password reset (by sending a foreign notification to the user).
     */
    async createPasswordResetRaw(requestParameters: CreatePasswordResetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.authenticationPasswordResetRequest === null || requestParameters.authenticationPasswordResetRequest === undefined) {
            throw new runtime.RequiredError('authenticationPasswordResetRequest','Required parameter requestParameters.authenticationPasswordResetRequest was null or undefined when calling createPasswordReset.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/credentials/password/reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthenticationPasswordResetRequestToJSON(requestParameters.authenticationPasswordResetRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates password reset (by sending a foreign notification to the user).
     */
    async createPasswordReset(requestParameters: CreatePasswordResetRequest, initOverrides?: RequestInit): Promise<void> {
        await this.createPasswordResetRaw(requestParameters, initOverrides);
    }

    /**
     * Reads the current authentication data.
     */
    async getMeRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
    }

    /**
     * Reads the current authentication data.
     */
    async getMe(initOverrides?: RequestInit): Promise<UserResponse> {
        const response = await this.getMeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Resets password.
     */
    async resetPasswordRaw(requestParameters: ResetPasswordRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.authenticationPasswordRequest === null || requestParameters.authenticationPasswordRequest === undefined) {
            throw new runtime.RequiredError('authenticationPasswordRequest','Required parameter requestParameters.authenticationPasswordRequest was null or undefined when calling resetPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/credentials/password`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AuthenticationPasswordRequestToJSON(requestParameters.authenticationPasswordRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resets password.
     */
    async resetPassword(requestParameters: ResetPasswordRequest, initOverrides?: RequestInit): Promise<void> {
        await this.resetPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * \\\"Unauthenticates\\\" the user.
     */
    async unauthenticateRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * \\\"Unauthenticates\\\" the user.
     */
    async unauthenticate(initOverrides?: RequestInit): Promise<void> {
        await this.unauthenticateRaw(initOverrides);
    }

}
